import { useState } from "react";
import { MAX_NAME_LENGTH } from "../lib/constants.js";
import styles from "./NamePrompt.module.css";

interface Props {
  onSubmit: (name: string) => void;
}

export function NamePrompt({ onSubmit }: Props) {
  const [name, setName] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    onSubmit(trimmed || "unknown");
  };

  return (
    <div className={styles.overlay}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <h1>お名前は？</h1>
        <p>アイテムを追加したとき、他のメンバーに表示されます。</p>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={MAX_NAME_LENGTH}
          placeholder="名前を入力"
          autoFocus
          aria-label="表示名"
        />
        <button type="submit">つづける</button>
      </form>
    </div>
  );
}
